<div [class.hide-in-print]="!!printOverviewService.data">
  <div>
    <router-outlet></router-outlet>
    <app-asset-transitioner></app-asset-transitioner>
    @if (showPicflowBranding && !onAssetPage) {
      <app-picflow-badge [tenantId]="tenant.id" [@picflowBadge]> </app-picflow-badge>
    }
  </div>
  <app-upload-info></app-upload-info>
  <app-archive-download-info></app-archive-download-info>
</div>
@if (printOverviewService.data) {
  <app-print-overview class="print"></app-print-overview>
}
